import React, { useState } from 'react';
import './App.css';
import ProgressBar from './ProgressBar';
import ProgressMaker from './ProgressMaker';

function App() {

  // Récupère une variable d'état "progress"
  // Et une fonction pour la modifier.
  // Initialise la valeur à 0.
  const [progress, setProgress] = useState(0);

  // Ajouter de la progression factice:
  ProgressMaker.start(setProgress);

  return (
    <div>
      <h1>Ma super application illustrative</h1>
      <ProgressBar progress={progress} />
    </div>
  );
}

export default App;
